import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Entry } from 'contentful';
import { ForgotPasswordPage } from 'src/app/model/page/group/user/forgot-password-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss']
})
export class ForgotPasswordPageComponent implements OnInit {
  forgotPasswordPage: ForgotPasswordPage = {} as ForgotPasswordPage;
  submitted = false;
  passwordResetSuccess = false;
  passwordResetForm: FormGroup = new FormGroup({
    email: new FormControl('')
  });
  constructor(private contentfulService: ContentfulService, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    const query = { 'fields.title': 'Forgot Password' };
    this.contentfulService.getPageContentWithEntries(query).then((forgotPasswordPageEntries) => {
      this.mapBanner(forgotPasswordPageEntries);
    });

    // console.log(this.forgotPasswordPage);
    this.passwordResetForm = this.formBuilder.group({
      eMail: ['', [Validators.required, Validators.email]]
    });
  }

  private mapBanner(forgotPasswordPageEntries: Entry<any>[]) {
    forgotPasswordPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.forgotPasswordPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
  resetPwdSubmit() {
    this.submitted = true;
    if (this.passwordResetForm.invalid) {
      return;
    } else {
      this.passwordResetSuccess = true;
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.passwordResetForm.controls;
  }
}
